import { Layout } from '@loadsmart/miranda-react'

import { isEmpty } from '../../utils/array'
import { type Commodity as CommodityType } from '../domain/Commodity'
import { type ShippingItemsMeasures, type ShippingItem } from '../domain/ShippingItem'
import { formatShippingItemToHandlingUnit } from '../presenters/HandlingUnitPresenter'
import Commodity from './Commodity'
import { HandlingUnit } from './HandlingUnit'
import { ShippingItemsSummary } from './ShippingItemsSummary'

export function ShippingItems({
  measures = {},
  shippingItems,
}: {
  measures?: ShippingItemsMeasures
  shippingItems: ShippingItem[]
}) {
  return (
    <Layout.Box backgroundColor="color-background-primary" padding="none">
      <ShippingItemsSummary
        measures={measures}
        count={shippingItems.length}
        showContent={measures && !isEmpty(shippingItems)}
      />
      {shippingItems.map((handlingUnit, index) => (
        <HandlingUnit index={index} handlingUnit={formatShippingItemToHandlingUnit(handlingUnit)}>
          {handlingUnit.commodities?.map((commodity: CommodityType) => (
            <Commodity commodity={commodity} />
          ))}
        </HandlingUnit>
      ))}
    </Layout.Box>
  )
}
